import { OtherString } from '../otherString';
import { ParsedDate } from '../parsed/parsedDate';
import { ParsedNumber } from '../parsed/parsedNumber';
import { PagedRequest } from '../request/pagedRequest';
import z from 'zod';

export const Cart = z.object({
    cartGuid: z.string(),
    cartId: z.string(),
    storeGuid: z.string(),
    maintenanceLocation: z.string().nullish(),
    maintenanceNote: z.string().nullish(),
    maintenanceMode: z.number().nullish(),
    isDisabled: z.boolean().nullish(),
    isGpsDisabled: z.boolean().nullish(),
    framenumber: z.string().nullish(),
    ip: z.string().nullish(),
    hostname: z.string().nullish(),
    desiredEnvironment: z.string().nullish(),
    location: z.string().nullish(),
    currentEnvironment: z.string().nullish(),
    deploymentStatus: z.string().nullish(),
    changedBy: z.string().nullish(),
    replacedByGuid: z.string().nullish(),
    replacedOn: ParsedDate.nullish(),
    batteryStatus: z
        .object({
            batteryLevel: z
                .number()
                .or(z.enum(['FULL', 'NORMAL', 'LOW', 'UNKNOWN']))
                .or(OtherString)
                .nullish(),
            charge: z.number().nullish(),
            chargingState: z.array(z.string()).nullish(),
            isChargerConnected: z.boolean().nullish(),
            ts: z.coerce.date().nullish(),
        })
        .nullish(),
    createdOn: ParsedDate.nullish(),
    modifiedOn: ParsedDate.nullish(),
    deletedOn: ParsedDate.nullish(),
});
export type Cart = z.infer<typeof Cart>;

export const CartDefectExternalTicket = z.object({
    createdOn: ParsedDate.nullish(),
    id: z.number().nullish(),
    modifiedOn: ParsedDate.nullish(),
    priority: ParsedNumber.nullish(),
    repairDate: ParsedDate.nullish(),
    hasReachedPendingStatus: z.boolean().nullish(),
    returnDate: ParsedDate.nullish(),
    hasReachedRepairInProgressStatus: z.boolean().nullish(),
    status: z.number().nullish(),
});
export type CartDefectExternalTicket = z.infer<typeof CartDefectExternalTicket>;

export const CartDefect = z.object({
    cartTicketGuid: z.string().nullish(),
    storeGuid: z.string().nullish(),
    cartGuid: z.string().nullish(),
    reasons: z.string().array().nonempty().nullish(),
    reasonsTechCodes: z.tuple([z.string(), z.string()]).nullish(),
    note: z.string().nullish(),
    isBroken: z.boolean().nullish(),
    changedBy: z.string().nullish(),
    externalTicket: CartDefectExternalTicket.nullish(),
    cart: Cart.nullish(),
    createdOn: ParsedDate.nullish(),
    modifiedOn: ParsedDate.nullish(),
});
export type CartDefect = z.infer<typeof CartDefect>;

export const CartTicketCreateRequestV2 = z.object({
    storeGuid: z.string(),
    cartGuid: z.string(),
    reasons: z.string().array().nullish(),
    reasonsTechCodes: z.string().array().nullish(),
    note: z.string().nullish(),
    isBroken: z.boolean().nullish(),
    image: z.string().nullish(),
    changedBy: z.string().nullish(),
});
export type CartTicketCreateRequestV2 = z.infer<typeof CartTicketCreateRequestV2>;

export const CartTicketCancelRequest = z.object({
    cartTicketGuid: z.string(),
    requestedBy: z.string().nullish(),
});
export type CartTicketCancelRequest = z.infer<typeof CartTicketCancelRequest>;

export const PagedCartDefectResponse = PagedRequest(CartDefect);
export type PagedCartDefectResponse = z.infer<typeof PagedCartDefectResponse>;

export const CartDefectRequestQuery = z.object({
    cartGuid: z.string(),
    limit: z.int().nullish(),
});
export type CartDefectRequestQuery = z.infer<typeof CartDefectRequestQuery>;

export const CartAndStoreDefectRequestQuery = z.object({
    storeGuid: z.string().nullish(),
    cartGuid: z.string().nullish(),
});
export type CartAndStoreDefectRequestQuery = z.infer<typeof CartAndStoreDefectRequestQuery>;
